<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <card-header
                :title="
                    $t('planPackageModules.form.texts.title', {
                        'title-prefix': $t('form.add-prefix'),
                    })
                "
            />

            <v-row class="pl-6" v-if="planPackage">
                <v-col>
                    <package-details :plan-package="planPackage" />
                </v-col>
            </v-row>

            <v-form ref="form" @submit.prevent="save">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <model-select
                                v-model="selectedModule"
                                name="module_id"
                                :model="moduleModel"
                                :item-text="'name'"
                                :item-value="'external_id'"
                                :label="
                                    $t('planPackageModules.form.labels.module')
                                "
                            />
                        </v-col>
                    </v-row>
                    <form-component
                        v-if="model"
                        :module="model"
                        :dependency-selection.sync="dependencySelection"
                        :courtesy-selection.sync="courtesySelection"
                        :combo-selection.sync="comboSelection"
                    />
                </v-card-text>

                <form-actions :loadingSave="loading" />
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import PlanPackage from '@/models/plans/PlanPackage'
import PlanPackageModule from '@/models/plans/PlanPackageModule'
import Module from '@/models/plans/Module'
import ModelSelect from '@/shared/inputs/ModelSelect'
import FormComponent from './Form.vue'
import PackageDetails from '@/views/planPackages/PackageDetails'

export default {
    props: ['id'],
    components: {
        CardHeader,
        FormActions,
        FormComponent,
        ModelSelect,
        PackageDetails,
    },
    data: () => ({
        model: null,
        loading: false,
        moduleModel: new Module(),
        selectedModule: null,
        dependencySelection: [],
        courtesySelection: [],
        comboSelection: [],
        planPackage: null,
    }),

    created() {
        this.init()
    },

    methods: {
        async init() {
            const planPackage = new PlanPackage()
            this.planPackage = await planPackage.find(this.id)

            this.model = new PlanPackageModule(this.id)

            this.$set(this.model, 'price', this.model.price || null)
            this.$set(this.model, 'price_type', this.model.price_type || 'flat')
            this.$set(this.model, 'add_on', this.model.add_on === true)
        },
        mapExtras() {
            this.model.dependency = (this.dependencySelection || []).map(m => ({
                id: m.external_id,
                module_id: m.external_id,
            }))
            this.model.courtesy = (this.courtesySelection || []).map(m => ({
                id: m.external_id,
                name: m.name,
                price: m.partner_price,
                module_id: m.external_id,
                price_type: m.price_type,
                external_id: null,
            }))
            this.model.combo = (this.comboSelection || []).map(m => ({
                id: m.external_id,
                name: m.name,
                price: m.partner_price,
                module_id: m.external_id,
                price_type: m.price_type,
                external_id: null,
            }))
        },
        async save() {
            this.loading = true
            this.mapExtras()
            const clone = this.model.clone()
            let res = null
            try {
                res = await clone.create().catch(() => {})
            } finally {
                this.loading = false
            }
            if (!res) return
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('planPackageModules.form.feedback.success'),
            )
            this.$router.push({
                name: 'planPackageModules.index',
                params: { id: this.id },
            })
        },
    },

    watch: {
        selectedModule(val) {
            this.$set(this.model, 'module_id', val ? val.external_id : null)
            this.$set(this.model, 'price', val ? val.partner_price : null)
            this.$set(
                this.model,
                'price_type',
                val
                    ? (val.price_type == 'per_unit'
                          ? 'unit'
                          : val.price_type) || 'flat'
                    : 'flat',
            )
        },
        'model.add_on'(val) {
            if (val === false) {
                this.model.amount = 1
            }
            if (val === true) {
                this.model.amount = 0
            }
        },
    },

    computed: {
        showAmount() {
            return (
                this.model &&
                this.model.price_type &&
                this.model.price_type !== 'flat'
            )
        },
    },
}
</script>
